(() => {
  const reviewSelectors = [
    '#judgeme_product_reviews',
    '.jdgm-all-reviews-widget-v2025',
    '.jdgm-rev-widg',
    '[data-judgeme-reviews]'
  ];

  const getReviewWidget = () =>
    reviewSelectors
      .map((selector) => document.querySelector(selector))
      .find(Boolean);

  const scrollToReviews = (attempt = 0) => {
    const reviewWidget = getReviewWidget();

    if (!reviewWidget) {
      if (attempt < 10) {
        window.setTimeout(() => scrollToReviews(attempt + 1), 300);
      }

      return;
    }

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    reviewWidget.style.scrollMarginTop = '9rem';

    reviewWidget.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };

  document.addEventListener('click', (event) => {
    const rating = event.target.closest(
      '.dentterity-product-info .jdgm-prev-badge, .dentterity-product-info .jdgm-preview-badge'
    );

    if (!rating) return;

    event.preventDefault();
    scrollToReviews();
  });
})();